import type { GetExchangeRatesMatrixResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useExchangeRatesMatrix(options?: CustomUseQueryOptions<GetExchangeRatesMatrixResponse>) {
  return useQuery(
    queryKeys.exchangeRatesMatrix(),
    async () => {
      const api = getPrivateApi();

      return api.getExchangeRatesMatrix();
    },
    options,
  );
}
